<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout wrap>
            <v-flex xs12 class="pt-0">
                <material-card color="#5cb860">
                    <v-flex slot="header">
                        <v-layout row>
                            <h3 class="title font-weight-light mt-4">
                                Recordings
                            </h3>
                            <v-card
                                class="mx-3 elevation-0"
                                style="background-color: #5cb860"
                            >
                                <v-layout row class="mt-1">
                                    <v-card-actions
                                        class="my-0 py-0"
                                        style="background-color: #fff; border-radius: 3px;"
                                        ><v-spacer></v-spacer>
                                        <v-text-field
                                            class="ml-2 mb-1 search-field"
                                            v-model="extensionSearch"
                                            @input="searchExtension"
                                            append-icon="mdi-search"
                                            label="Extension"
                                            hide-details
                                        ></v-text-field
                                    ></v-card-actions>
                                    <v-card-actions
                                        class="my-0 py-0"
                                        style="background-color: #fff; border-radius: 3px;"
                                    >
                                        <v-text-field
                                            v-model="recordingNumberSearch"
                                            append-icon="mdi-search"
                                            label="Recording Number"
                                            class="ml-2 mb-1 search-field"
                                            @input="searchRecording"
                                            hide-details
                                        ></v-text-field>
                                    </v-card-actions>
                                </v-layout> </v-card
                            ><v-spacer></v-spacer>
                            <v-btn
                                style="background-color: #FFF"
                                class="ma-0 button-text"
                                @click="openEditRecordingDialog()"
                                >Edit Recordings</v-btn
                            >
                        </v-layout>
                    </v-flex>
                    <v-data-table
                        :headers="headers"
                        :items="recordings"
                        v-model="selected"
                        item-key="Key"
                        select-all
                        v-bind:pagination.sync="pagination"
                        hide-actions
                        disable-initial-sort
                    >
                        <template slot="headerCell" slot-scope="{ header }">
                            <span
                                class="font-weight-light text-success text--darken-3"
                                v-text="header.text"
                            />
                        </template>
                        <template v-slot:items="props">
                            <td>
                                <v-checkbox
                                    color="#5cb860"
                                    v-model="props.selected"
                                    primary
                                    hide-details
                                ></v-checkbox>
                            </td>
                            <td
                                style="min-width: 200px"
                                class="text-xs-left font-weight-regular"
                            >
                                {{ props.item.Date }}
                            </td>
                            <td class="text-xs-left font-weight-regular">
                                {{ props.item.CallerID }}
                            </td>
                            <td class="text-xs-left font-weight-regular">
                                {{ props.item.Extension }}
                            </td>
                            <td class="text-xs-left font-weight-regular">
                                {{ props.item.RecordingNumber }}
                            </td>
                            <td>
                                <audio controls :src="props.item.URL"></audio>
                            </td>
                        </template>
                    </v-data-table>
                    <div class="text-xs-center mt-2">
                        <v-pagination
                            v-model="pagination.page"
                            :length="pages"
                            :total-visible="5"
                        ></v-pagination>
                    </div>
                </material-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="editRecordingsDialog" max-width="1000">
            <v-card class="pa-3">
                <v-card-title class="headline mb-2 pl-0"
                    >Edit Recordings</v-card-title
                >
                <div v-for="(recording, index) in recordingsToEdit">
                    <v-layout row>
                        <div style="width: 15%">{{ recording.CallerID }}</div>
                        <div style="width: 20%" class="mr-2">
                            {{ recording.Date }}
                        </div>
                        <v-text-field
                            style="width: 10%"
                            class="mx-2"
                            label="Extension"
                            v-model="recording.Extension"
                            type="number"
                        ></v-text-field>
                        <v-text-field
                            style="width: 10%"
                            class="mx-2"
                            label="Recording Number"
                            v-model="recording.RecordingNumber"
                            type="number"
                        ></v-text-field>
                        <v-text-field
                            style="width: 10%"
                            class="mx-2"
                            label="Message Number"
                            v-model="recording.MessageNumber"
                            type="number"
                        ></v-text-field>
                        <audio controls :src="recording.URL"></audio>
                    </v-layout>
                    <v-divider
                        class="mb-1"
                        v-if="index + 1 < selected.length"
                    ></v-divider>
                </div>

                <v-card-actions class="mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        class="unset-color"
                        color="#999"
                        @click="editRecordingsDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        dark
                        class="unset-color"
                        color="#5cb860"
                        @click="saveRecordings"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/database";
import moment from "moment";

export default {
    data() {
        return {
            selected: [],
            extensionSearch: "",
            recordingNumberSearch: "",
            rowsPerPageItems: [10, 20],
            pagination: {
                totalItems: 0,
                rowsPerPage: 10,
                page: 1,
            },

            editRecordingsDialog: false,

            headers: [
                { value: "CallerID", text: "Caller ID" },
                { value: "Timestamp", text: "Timestamp" },
                { value: "Extension", text: "Extension" },
                { value: "RecordingNumber", text: "Recording Number" },
                { value: "URL", text: "Recording" },
            ],

            recordings: [],
            recordingsList: [],
            recordingsToEdit: [],

            kollelRef: "",
        };
    },
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.pagination.totalItems / this.pagination.rowsPerPage
                  )
                : 0;
        },
    },
    created() {
        this.firebaseSetup();
    },
    methods: {
        firebaseSetup() {
            const firebaseConfig = {
                apiKey: "Xs6kU5UjjL8n5LdLQJMGnWcaEietBLrj5U9FnpIb",
                authDomain: "broadcast-b7a56.firebaseapp.com",
                databaseURL: "https://broadcast-b7a56.firebaseio.com",
                projectId: "broadcast-b7a56",
            };

            // Initialize Firebase
            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            var database = firebase.database();
            var ref = firebase.database().ref("kollelCorona");

            const kollelRef = ref.orderByKey().limitToLast(300);

            this.kollelRef = kollelRef;

            kollelRef.on(
                "value",
                (snapshot) => {
                    const recordings = Object.keys(snapshot.val())
                        .map((key) => {
                            const obj = snapshot.val()[key];

                            obj.Key = key;

                            return obj;
                        })
                        .map((message) => {
                            message.CallerID = this.formatPhoneNumber(
                                message.CallerID
                            );

                            message.Date = moment(message.Timestamp).format(
                                "LLL"
                            );

                            return message;
                        });
                    this.recordings = recordings.sort((a, b) => {
                        if (Date.parse(a.Timestamp) > Date.parse(b.Timestamp))
                            return -1;
                        if (Date.parse(a.Timestamp) < Date.parse(b.Timestamp))
                            return 1;
                        return 0;
                    });

                    this.recordingsList = this.recordings;

                    this.pagination.totalItems = this.recordings.length;
                },
                function(error) {
                    console.log("Error: " + error.code);
                }
            );

            ref.on("child_added", (data, prevChildKey) => {});
        },
        formatPhoneNumber(phoneNumberString) {
            var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return "(" + match[1] + ") " + match[2] + "-" + match[3];
            }
            return null;
        },
        searchExtension(value) {
            if (!value) {
                this.recordings = this.recordingsList;
            }

            this.recordings = this.recordingsList.filter((recording) => {
                return recording.Extension.toString().includes(value);
            });
        },
        searchRecording(value) {
            if (!value) {
                this.recordings = this.recordingsList;
            }

            this.recordings = this.recordingsList.filter((recording) => {
                return recording.RecordingNumber.toString().includes(value);
            });
        },
        saveRecordings() {
            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            var database = firebase.database();
            var ref = firebase.database().ref("kollelCorona");

            this.recordingsToEdit.forEach((recording) => {
                const key = recording.Key;

                delete recording.Key;
                delete recording.Date;

                ref.child(key).update(recording);
            });

            this.editRecordingsDialog = false;
            this.selected = [];
        },
        getStatusIcon(status) {
            switch (status) {
                case "Completed":
                    return "mdi-check-circle";
                case "InProgress":
                    return "mdi-progress-upload";
                case "Pending":
                    return "mdi-clock";
            }
        },
        getStatusIconColor(status) {
            switch (status) {
                case "Completed":
                    return "success";
                case "InProgress":
                    return "#42A5F5";
                case "Pending":
                    return "#fdb400";
            }
        },
        openEditRecordingDialog() {
            this.recordingsToEdit = JSON.parse(JSON.stringify(this.selected));

            this.editRecordingsDialog = true;
        },
    },
};
</script>
<style>
tbody tr:nth-child(even) {
    background-color: #eee;
}

.search-field input {
    color: #495057 !important;
}

.button-text .v-btn__content {
    color: #4caf50 !important;
}

.unset-color.v-btn__content {
    color: black !important;
}
</style>
